import { Typography, TypographyProps } from "antd";

import styled from "styled-components";

import themeManager from "project-config/services/theme-manager";

export const StyledText = styled(Typography.Text)`
  &.renderbus-ui-text {
    &.ant-typography {
      color: ${(p) => p.color || themeManager.newTheme?.["gray-9"]};
      font-size: 12px;
      width: ${(p) => p.width || ""};
      min-width: ${(p) => p.minWidth || ""};
    }
    &.ant-typography-ellipsis-single-line {
      vertical-align: middle;
    }
  }
`;
